import { createSelector } from 'reselect';

const jobSelector = state => state.job;
const createJobSelector = createSelector(jobSelector, jobData => jobData);

export default createJobSelector;
